/**
 * @module app
 */

/**
 * @fileoverview This file defines the application's Angular module.
 */

import ngeoMainmodule from './ngeoMainmodule';
import appBasemaps from './basemaps.js';
import appConfigApiservice from './config/apiservice.js';
import appConfigBicyclespeed from './config/bicyclespeed.js';
import appConfigColor from './config/color.js';
import appConfigFilter from './config/filter.js';
import appConfigGeneral from './config/general.js';
import appConfigGpspoints from './config/gpspoints.js';
import appConfigOpacity from './config/opacity.js';
import appConfigStateservice from './config/stateservice.js';
import appConfigTimetype from './config/timetype.js';
import appConfigPublic from './config/public.js';
import appQueryState from './query/state.js';
import appLoadingspinner from './loadingspinner.js';
import appMap from './map.js';
import appMenu from './menu.js';
import appPrintService from './printService.js';
import appRouter from './router.js';
import appTooltip from './tooltip.js';
import appTrackTracksController from './track/TracksController.js';
import appTrackConfig from './track/config.js';
import appTrackGpx from './track/gpx.js';
import appTrackFilters from './track/filters.js';
import appTrackPrint from './track/print.js';
import appTrackShare from './track/share.js';
import appCarousel from './carousel.js';
import appWaiting from './waiting.js';
import {mockProvider} from "./utils";
import {useCookieBasedAuth} from './authMode.js';


/**
 * @type {!angular.Module}
 */
export default angular.module('app', [
  ngeoMainmodule.name,
  'gettext',
  'ngSanitize',
  'ui.router',
  appBasemaps.name,
  appConfigApiservice.name,
  appConfigBicyclespeed.name,
  appConfigColor.name,
  appConfigFilter.name,
  appConfigGeneral.name,
  appConfigGpspoints.name,
  appConfigOpacity.name,
  appConfigStateservice.name,
  appConfigTimetype.name,
  appConfigPublic.name,
  appQueryState.name,
  appLoadingspinner.name,
  appMap.name,
  appMenu.name,
  appPrintService.name,
  appTooltip.name,
  appTrackTracksController.name,
  appTrackConfig.name,
  appTrackGpx.name,
  appTrackFilters.name,
  appTrackPrint.name,
  appTrackShare.name,
  appCarousel.name,
  appWaiting.name,
])
  .config(mockProvider) // What's this?? - required for routes handling
  .config(appRouter)
  .run(['$http', function($http) {
    $http.defaults.withCredentials = true;
  }])
  .factory('authInterceptor', function($q, $window, $injector, apiUrl) {
    return {
      request: async function(config) {
        const authService = $injector.get('appAuthenticationService');
        if (useCookieBasedAuth) {
          return config;
        }
        try {
          const token = await authService.oidcClient.getActiveToken();
          if (config.url.includes(apiUrl) && token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (e) {
          console.warn(e);
          authService.logout();
        }

        return config;
      },
      responseError: function(rejection) {
        return $q.reject(rejection);
      }
    };
  })
  .config(function($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
  });


angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
  return function(exception, cause) {
    exception.message += ' (caused by "' + cause + '")';
    throw exception;
  };
});
